/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Person';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const PersonIcon = withMuiAdapter(Base, 'Person');
